"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const core_1 = require("@angular/core");
const router_1 = require("@angular/router");
const ngx_spinner_1 = require("ngx-spinner");
const common_1 = require("@angular/common");
const account_service_1 = require("../../account/account.service");
const auth_service_1 = require("../../authentication/auth.service");
const models_1 = require("../../models");
const _ = tslib_1.__importStar(require("underscore"));
const ngx_toastr_1 = require("ngx-toastr");
const rxjs_1 = require("rxjs");
const sidenav_service_1 = require("../../layouts/side-menu/sidenav/sidenav.service");
let KitViewComponent = class KitViewComponent {
    constructor(route, router, toaster, spinner, accountService, sideNavService, authService) {
        this.route = route;
        this.router = router;
        this.toaster = toaster;
        this.spinner = spinner;
        this.accountService = accountService;
        this.sideNavService = sideNavService;
        this.authService = authService;
        this.isDataFetched = false;
        this.xPointsCount = 8;
        this.currentGraphRangeType = 0;
        this.formType = models_1.FORM_TYPE.EDIT;
        this.showForm = false;
        this.isCloning = false;
        this.redrawGraphEvent = new rxjs_1.BehaviorSubject(null);
        this.graphDataObservable = this.redrawGraphEvent.asObservable();
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
    }
    ngOnInit() {
        this.route.params.subscribe(params => {
            this.deviceId = params['deviceId'];
        });
        const lastGraphRangeType = parseInt(localStorage.getItem('graphRangeType' + this.deviceId), 10);
        this.graphRangeType = lastGraphRangeType ? lastGraphRangeType : 0;
        const temp = ((window.innerWidth * 0.55) / 80);
        this.xPointsCount = temp - temp % 1;
        this.getKit();
        const today = new Date();
        this.toDate = today;
        this.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7);
    }
    onKitUpdated() {
        this.showForm = false;
        this.isCloning = false;
        this.properties = null;
        const url = this.router.url;
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this.router.navigateByUrl(url);
        });
    }
    getKit() {
        this.spinner.show();
        this.accountService.getKit(this.deviceId)
            .subscribe(response => {
            this.kit = response.content;
            const firstDevice = this.kit.devices[0];
            this.accountService.deviceName.next(firstDevice ? String(firstDevice) : '');
            this.loadGraph();
        }, error => {
            this.spinner.hide();
        });
    }
    hideForm() {
        this.isCloning = false;
        this.showForm = false;
    }
    getKits() {
        this.accountService.getKits().subscribe(response => {
            this.kits = response.content;
            this.isDataFetched = true;
            this.spinner.hide();
        }, error => {
            this.spinner.hide();
        });
    }
    editKit(kit) {
        this.accountService.getKit(this.deviceId).subscribe(response => {
            this.selectedKit = response.content;
            this.formType = models_1.FORM_TYPE.EDIT;
            this.devices = Object.assign([], this.devicesAll);
            this.devicesOfKit = this.selectedKit.devices.map(device => {
                return _.findWhere(this.devices, { id: device });
            });
            this.selectedKit['kitModel'] = this.selectedKit.model.id;
            this.selectedKit['soilType'] = this.selectedKit.metaData ? this.selectedKit.metaData.soilType : '';
            this.showForm = true;
        }, error => {
            console.error('Error fetching kit:', error);
        });
    }
    loadGraph() {
        this.currentGraphRangeType = this.graphRangeType;
        localStorage.setItem('graphRangeType' + this.deviceId, '' + this.graphRangeType);
        const today = new Date();
        if (this.graphRangeType === 2) {
            this.toDate = today;
            this.fromDate = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());
        }
        else if (this.graphRangeType === 1) {
            this.toDate = today;
            this.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7);
        }
        else if (this.graphRangeType === 0) {
            this.toDate = today;
            this.fromDate = today;
        }
        this.toString = common_1.formatDate(this.toDate, 'yyyy-MM-dd', 'lk');
        this.fromString = common_1.formatDate(this.fromDate, 'yyyy-MM-dd', 'lk');
        this.spinner.show();
        this.accountService.getDeviceHistoryAll(this.deviceId, this.fromString, this.toString)
            .subscribe(data => {
            if (data.statusCode === 'E1003') {
                this.error = 'No Data Available';
            }
            this.graphs = data.content || null;
            this.isDataFetched = true;
            this.redrawGraphEvent.next(this.graphs);
            this.spinner.hide();
        }, error => {
            this.spinner.hide();
        }, () => {
            this.spinner.hide();
        });
    }
    getKitProperties() {
        if (!this.properties) {
            const properties = Object.assign([], this.kit.properties);
            const battery = this.kit.battery;
            if (battery) {
                const batteryProperty = {
                    number: properties.length, displayValue: battery.reading + '%', displayName: 'Battery',
                    code: '-10', time: '', alert: battery.low > battery.reading, error: false, showThreshold: false
                };
                properties.push(batteryProperty);
            }
            this.properties = properties;
        }
        return this.properties;
    }
    isSideNavVisible() {
        return this.sideNavService.isSideNavVisible;
    }
    isSuperUser() {
        return auth_service_1.AuthService.isSuperAdmin();
    }
};
KitViewComponent.ctorParameters = () => [
    { type: router_1.ActivatedRoute },
    { type: router_1.Router },
    { type: ngx_toastr_1.ToastrService },
    { type: ngx_spinner_1.NgxSpinnerService },
    { type: account_service_1.AccountService },
    { type: sidenav_service_1.SideNavService },
    { type: auth_service_1.AuthService }
];
KitViewComponent = tslib_1.__decorate([
    core_1.Component({
        selector: 'app-kit-view',
        template: tslib_1.__importDefault(require("!raw-loader!./kit-view.component.html")).default,
        styles: [tslib_1.__importDefault(require("./kit-view.component.css")).default]
    }),
    tslib_1.__metadata("design:paramtypes", [router_1.ActivatedRoute, router_1.Router, ngx_toastr_1.ToastrService,
        ngx_spinner_1.NgxSpinnerService, account_service_1.AccountService, sidenav_service_1.SideNavService,
        auth_service_1.AuthService])
], KitViewComponent);
exports.KitViewComponent = KitViewComponent;
//# sourceMappingURL=kit-view.component.js.map